import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import {
    AgentConversationScope,
    fetchConversations,
    fetchConversation,
    deleteConversation,
} from './service'

const agentKeys = {
    all: ['agent'] as const,
    conversations: (scope: AgentConversationScope = 'general', studioDraftDocId?: string | null) =>
        [...agentKeys.all, 'conversations', scope, studioDraftDocId || ''] as const,
    conversation: (id: string) => [...agentKeys.all, 'conversation', id] as const,
}

export function useAgentConversations(
    limit = 20,
    scope: AgentConversationScope = 'general',
    studioDraftDocId?: string | null
) {
    return useQuery({
        queryKey: agentKeys.conversations(scope, studioDraftDocId),
        queryFn: () => fetchConversations(limit, scope, studioDraftDocId),
        staleTime: 30000,
    })
}

export function useAgentConversation(id: string | null) {
    return useQuery({
        queryKey: agentKeys.conversation(id || ''),
        queryFn: () => fetchConversation(id!),
        enabled: !!id,
        staleTime: 60000,
    })
}

export function useDeleteConversation() {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: deleteConversation,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [...agentKeys.all, 'conversations'] })
        },
    })
}

export function useInvalidateConversations(scope: AgentConversationScope = 'general') {
    const queryClient = useQueryClient()
    return () => queryClient.invalidateQueries({ queryKey: agentKeys.conversations(scope) })
}
